document.addEventListener("DOMContentLoaded", function() {
    // Smooth scrolling for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
        anchor.addEventListener('click', function(event) {
            event.preventDefault();

            var target = document.querySelector(this.hash);
            if (target) {
                window.scrollTo({
                    top: target.offsetTop - 80,
                    behavior: 'smooth'
                });
            }
        });
    });

    // Scroll and tab switching for elements with the class "scrollon"
    document.querySelectorAll('.scrollon').forEach(function(scrollon) {
        scrollon.addEventListener('click', function(event) {
            event.preventDefault();

            var target = document.querySelector(this.getAttribute('data-href'));
            var target_id = this.getAttribute('data-id');
            var offsetSpace = 40;

            console.log(target.offsetTop);

            if (window.innerWidth > 1080) {
                offsetSpace = offsetSpace + 100;
            }

            if (target) {
                window.scrollTo({
                    top: target.offsetTop - offsetSpace,
                    behavior: 'smooth'
                });
            }

            // Tab switching logic
            if (target_id === 'cta-ingredients') {
                document.querySelectorAll('#ingredientes-y-uso .product-simple-tab-header-wrapper, #ingredientes-y-uso .product-simple-tab-content').forEach(function(el) {
                    el.classList.remove('active');
                });
                document.querySelectorAll('[data-tab-ingredientes], [data-content-ingredientes]').forEach(function(el) {
                    el.classList.add('active');
                });
            }

            if (target_id === 'cta-use') {
                document.querySelectorAll('#ingredientes-y-uso .product-simple-tab-header-wrapper, #ingredientes-y-uso .product-simple-tab-content').forEach(function(el) {
                    el.classList.remove('active');
                });
                document.querySelectorAll('[data-tab-modo-de-uso], [data-content-modo-de-uso]').forEach(function(el) {
                    el.classList.add('active');
                });
            }

            if (target_id === 'cta-details') {
                document.querySelectorAll('#detalles .product-section-tab-header-wrapper, #detalles .product-section-tab-content').forEach(function(el) {
                    el.classList.remove('active');
                });
                document.querySelectorAll('[data-tab-detalles], [data-content-detalles]').forEach(function(el) {
                    el.classList.add('active');
                });
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', function() {
  // Select all sections with an id attribute
  const sections = document.querySelectorAll('.scrollcheck[id]');
  
  // Function to add 'active' class to the first matching data-href element
  function onScroll() {
    let currentSectionId = '';
    
    sections.forEach(section => {
      const sectionTop = section.offsetTop - 100; // Adjust based on your preference
      const sectionHeight = section.offsetHeight;
      
      if (window.scrollY >= sectionTop && window.scrollY < sectionTop + sectionHeight) {
        currentSectionId = '#' + section.getAttribute('id');
      }
    });
    
    // Remove 'active' class from all data-href elements
    document.querySelectorAll('[data-href-mob]').forEach(link => {
      link.classList.remove('active');
      link.classList.remove('active-force');
    });
    
    // Add 'active' class to the first element with matching data-href-mob
    if (currentSectionId) {
      const firstMatch = document.querySelector(`[data-href-mob="${currentSectionId}"]`);
      if (firstMatch) {
        firstMatch.classList.add('active');
        document.querySelectorAll('[data-href-mob]').forEach(link => {
          link.classList.remove('active-force');
        });
      }
    }
  }
  
  // Attach the scroll event listener
  window.addEventListener('scroll', onScroll);



  const ctaUseElements = document.querySelectorAll('[data-id="cta-use"]');
  const ctaIngredientsElements = document.querySelectorAll('[data-id="cta-ingredients"]');
  const scrollonElements = document.querySelectorAll('.scrollon');

  if (ctaUseElements.length > 0) {
    ctaUseElements[0].addEventListener('click', function() {
      if (scrollonElements.length > 0) {
        scrollonElements.forEach(function(element) {
          element.classList.remove('active-force', 'active');
        });
      }

      ctaUseElements.forEach(function(element) {
        element.classList.add('active-force');
      });
    });
  }

  if (ctaIngredientsElements.length > 0) {
    ctaIngredientsElements[0].addEventListener('click', function() {
      if (scrollonElements.length > 0) {
        scrollonElements.forEach(function(element) {
          element.classList.remove('active-force', 'active');
        });
      }

      ctaIngredientsElements.forEach(function(element) {
        element.classList.add('active-force');
      });
    });
  }
});

function checkCart() {
  fetch('/cart.js')
  .then(response => {
    if (!response.ok) {
      throw new Error('Error en la red');
    }
    return response.json();
  })
  .then(cart => {
    let totalItems = cart.item_count;
    document.querySelectorAll('.header-icon-cart-count-text span').forEach(cartCountBubble => {
      cartCountBubble.textContent = totalItems ?? 0;
    });
  })
  .catch(error => {
      console.error('Error:', error);
  });
}


window.upcartOnCartUpdated = function (cart) {
  checkCart();
}